// ============================================================
//  TEAM BUILDING BOOKING BLOCK
//  Upload to: Shopify Admin → Themes → Edit code → Assets
// ============================================================

// ============================================================
//  PROJECT OPTIONS — edit seasonally
// ============================================================
var TB_PROJECTS = [
  { label: "Clay", options: ["The Blobs","Kitty Blob Cup","Splatter Bowl","Mushroom Mugs","Bunny Mugs","Fairy Doors","Tiny Pause Candle Holder","Little Ghosties","Cedar Mugs","Polar Mugs","Glow Trees","Things I Love Mug Xmas","Yeti Mug","Penguins Mugs","Frosty Mugs","Holidays Fairy Door"] },
  { label: "Ditto Oven-Bake Clay", options: ["Fairy Doors","Pumpkin Spice Sweater","Hyggely Sweaters","Holiday Cutie Baby Animal Wreath","Little Helper Sweaters","North Pole Fairy Doors","Colossal Yeti","Penguins","Owls","Lil Cat Name Tag Holder","Group Portrait"] },
  { label: "Painting", options: [,"Van Gogh's Sunflowers","Monet's Garden","Bumble Bee","Paint Pouring"] }
];

// ============================================================
//  STUDIO MAP
// ============================================================
var TB_STUDIOS = {
  "British Columbia": [
    { name: "Richmond \u2013 Garden City",         variantName: "BC / RICHMOND - GARDEN CITY" },
    { name: "Richmond \u2013 Steveston",           variantName: "BC / RICHMOND - STEVESTON" },
    { name: "Surrey \u2013 South",                variantName: "BC / SURREY - SOUTH" },
    { name: "Vancouver \u2013 Kitsilano",          variantName: "BC / VANCOUVER - KITSILANO" },
    { name: "Vancouver \u2013 Main Street",        variantName: "BC / VANCOUVER - MAIN STREET" },
    { name: "Vancouver \u2013 UBC",               variantName: "BC / VANCOUVER - UBC" },
    { name: "Victoria \u2013 Cook Street Village", variantName: "BC / VICTORIA - COOK STREET VILLAGE" },
    { name: "Victoria \u2013 Esquimalt",           variantName: "BC / VICTORIA - ESQUIMALT" },
    { name: "Victoria \u2013 Oak Bay",             variantName: "BC / VICTORIA - OAK BAY" },
    { name: "Victoria \u2013 Uptown",              variantName: "BC / VICTORIA - UPTOWN" }
  ],
  "Alberta": [
    { name: "Calgary \u2013 Inglewood", variantName: "AB / CALGARY - INGLEWOOD" },
    { name: "St. Albert",              variantName: "AB / ST ALBERT" }
  ],
  "Ontario": [
    { name: "Burlington \u2013 South",            variantName: "ON / BURLINGTON - SOUTH" },
    { name: "Cambridge \u2013 Galt",              variantName: "ON / CAMBRIDGE - GALT" },
    { name: "Erin",                              variantName: "ON / ERIN" },
    { name: "Hamilton \u2013 Ottawa Street",      variantName: "ON / HAMILTON - OTTAWA STREET" },
    { name: "Hamilton \u2013 Waterdown",          variantName: "ON / HAMILTON - WATERDOWN" },
    { name: "Hamilton \u2013 West Harbour",       variantName: "ON / HAMILTON - WEST HARBOUR" },
    { name: "Kingston \u2013 Arlington Park",     variantName: "ON / KINGSTON - ARLINGTON PARK" },
    { name: "London \u2013 Byron",                variantName: "ON / LONDON - BYRON" },
    { name: "London \u2013 Wortley Village",      variantName: "ON / LONDON - WORTLEY VILLAGE" },
    { name: "Mississauga \u2013 Port Credit",     variantName: "ON / MISSISSAUGA - PORT CREDIT" },
    { name: "Oakville \u2013 North",              variantName: "ON / OAKVILLE - NORTH" },
    { name: "Oakville \u2013 West",               variantName: "ON / OAKVILLE - WEST" },
    { name: "Ottawa \u2013 The Glebe",            variantName: "ON / OTTAWA - THE GLEBE" },
    { name: "St. Catharines",                    variantName: "ON / ST CATHARINES" },
    { name: "Toronto \u2013 Avenue Road",         variantName: "ON / TORONTO - AVENUE ROAD" },
    { name: "Toronto \u2013 Baby Point",          variantName: "ON / TORONTO - BABY POINT" },
    { name: "Toronto \u2013 Leaside",             variantName: "ON / TORONTO - LEASIDE" },
    { name: "Toronto \u2013 The Beaches",         variantName: "ON / TORONTO - THE BEACHES" },
    { name: "Waterloo \u2013 Uptown",             variantName: "ON / WATERLOO - UPTOWN" }
  ]
};

// ============================================================
//  PRICING
// ============================================================
var TB_EXTRAS_HANDLE = 'adult-get-togethers-extra-guests-time';
var TB_EXTRAS_BASE_KEY = 'up to 10 people (base price) / no - just we will leave after the art portion';

var TB_GUEST_OPTIONS = [
  { value: 'up to 10 people (base price)', label: 'Up to 10 people' },
  { value: '11 people', label: '11 people' }, { value: '12 people', label: '12 people' },
  { value: '13 people', label: '13 people' }, { value: '14 people', label: '14 people' },
  { value: '15 people', label: '15 people' }, { value: '16 people', label: '16 people' },
  { value: '17 people', label: '17 people' }, { value: '18 people', label: '18 people' },
  { value: '19 people', label: '19 people' }, { value: '20 people', label: '20 people' },
  { value: '21 people', label: '21 people' }, { value: '22 people', label: '22 people' },
  { value: '23 people', label: '23 people' }, { value: '24 people', label: '24 people' },
  { value: '25 people', label: '25 people' }, { value: '26 people', label: '26 people' },
  { value: '27 people', label: '27 people' }, { value: '28 people', label: '28 people' },
  { value: '29 people', label: '29 people' }, { value: '30 people', label: '30 people' }
];
var tbExtrasVariantMap = {};

// ============================================================
//  STATE
// ============================================================
var tbState = {
  province: null,
  studioName: null,
  studioVariantName: null,
  dateKey: null,
  dateLabel: null,
  variantId: null,
  variantPrice: null,
  timeLabel: null,
  guests: 'up to 10 people (base price)',
  guestsLabel: 'Up to 10 people',
  extraTime: 'no - just we will leave after the art portion',
  extraTimeLabel: 'No \u2013 just the art session',
  occasion: '',
  project: '',
  calYear: null,
  calMonth: null,
  dateMap: {}
};

// Steps in order
var TB_STEP_IDS = ['province','studio','date','time','guests','extratime','occasion','project','review'];
var tbCurrentStep = 0;

// ============================================================
//  INIT
// ============================================================
function tbInit() {
  var block = document.getElementById('tb-booking-block');
  if (!block || block.dataset.tbReady) return;
  block.dataset.tbReady = '1';
  tbBuildProvinceOptions();
  tbBuildGuestOptions();
  tbBuildProjectOptions();
  tbBindExtraTimeButtons();
  document.getElementById('tb-add-to-cart').addEventListener('click', tbAddToCart);

  // Pre-select studio from URL param
  if (window.__TB_PRESELECT__) {
    var pre = window.__TB_PRESELECT__;
    tbState.province = pre.province;
    tbBuildStudioOptions(pre.province);
    var studiosInProv = TB_STUDIOS[pre.province] || [];
    var match = null;
    studiosInProv.forEach(function(s) {
      if (s.name === pre.studioName) match = s;
    });
    if (match) {
      var labelEl = document.getElementById('tb-studio-label');
      if (labelEl) { labelEl.textContent = '📍 ' + match.name; labelEl.style.display = 'block'; }
      tbState.studioName = match.name;
      tbState.studioVariantName = match.variantName;
      tbState.dateKey = null; tbState.variantId = null;
      tbGoTo(2);
      setTimeout(function() { tbFetch(match.variantName); }, 100);
    } else {
      tbGoTo(1);
    }
    window.__TB_PRESELECT__ = null;
    return;
  }

  tbGoTo(0);
}

tbInit();
document.addEventListener('DOMContentLoaded', tbInit);
window.addEventListener('load', tbInit);

// ============================================================
//  NAVIGATION
// ============================================================
function tbGoTo(stepIndex) {
  tbCurrentStep = stepIndex;
  TB_STEP_IDS.forEach(function(id, i) {
    var el = document.getElementById('tb-step-' + id);
    if (el) el.className = 'tb-step' + (i === stepIndex ? ' tb-step-active' : '');
  });
  var pct = ((stepIndex + 1) / TB_STEP_IDS.length * 100).toFixed(0) + '%';
  var bar = document.getElementById('tb-progress-bar');
  var lbl = document.getElementById('tb-progress-label');
  var back = document.getElementById('tb-back-btn');
  if (bar) bar.style.width = pct;
  if (lbl) lbl.textContent = 'Step ' + (stepIndex + 1) + ' of ' + TB_STEP_IDS.length;
  if (back) back.style.display = stepIndex > 0 ? 'inline-block' : 'none';
  // Scroll to top of block
  var block = document.getElementById('tb-booking-block');
  if (block) setTimeout(function() { block.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 50);
}

function tbBack() {
  if (tbCurrentStep > 0) tbGoTo(tbCurrentStep - 1);
}

function tbNext() {
  tbGoTo(tbCurrentStep + 1);
}

// ============================================================
//  STEP 1: Province
// ============================================================
function tbBuildProvinceOptions() {
  var container = document.getElementById('tb-province-options');
  if (!container) return;
  Object.keys(TB_STUDIOS).forEach(function(province) {
    var btn = document.createElement('button');
    btn.className = 'tb-option-btn';
    btn.textContent = province;
    btn.addEventListener('click', function() {
      tbState.province = province;
      tbBuildStudioOptions(province);
      tbNext();
    });
    container.appendChild(btn);
  });
}

// ============================================================
//  STEP 2: Studio
// ============================================================
function tbBuildStudioOptions(province) {
  var container = document.getElementById('tb-studio-options');
  if (!container) return;
  container.innerHTML = '';
  (TB_STUDIOS[province] || []).forEach(function(studio) {
    var btn = document.createElement('button');
    btn.className = 'tb-option-btn';
    btn.textContent = studio.name;
    btn.addEventListener('click', function() {
      tbState.studioName = studio.name;
      tbState.studioVariantName = studio.variantName;
      tbState.dateKey = null; tbState.variantId = null;
      var labelEl = document.getElementById('tb-studio-label');
      if (labelEl) { labelEl.textContent = '📍 ' + studio.name; labelEl.style.display = 'block'; }
      tbGoTo(2);
      tbFetch(studio.variantName);
    });
    container.appendChild(btn);
  });
}

// ============================================================
//  FETCH
// ============================================================
var TB_SUPABASE_URL = 'https://snxibhbhhchjthfmjtaj.supabase.co';
var TB_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNueGliaGJoaGNoanRoZm1qdGFqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcwNTk2ODAsImV4cCI6MjA5MjYzNTY4MH0.K-89Mx4SxU6N1hMmtK6Q79rWAtk6VTN9b5wemQxcZVA';
var TB_COLLECTION_ID = '301970751578';

function tbFetch(variantName) {
  document.getElementById('tb-loading').style.display = 'block';
  document.getElementById('tb-calendar').innerHTML = '';

  var url = TB_SUPABASE_URL + '/functions/v1/public-collection-products?collection_id=' + encodeURIComponent(TB_COLLECTION_ID);

  fetch(url, { headers: { Authorization: 'Bearer ' + TB_ANON_KEY, apikey: TB_ANON_KEY } })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var all = (data && data.products) || [];
      var target = variantName.toUpperCase().trim();
      var products = [];
      all.forEach(function(p) {
        (p.variants || []).forEach(function(v) {
          if ((v.title || '').toUpperCase().trim() === target && v.available) {
            products.push({ title: p.title, variantId: v.id, price: Math.round(parseFloat(v.price) * 100) });
          }
        });
      });
      document.getElementById('tb-loading').style.display = 'none';
      // Build date map
      tbState.dateMap = {};
      products.forEach(function(p) {
        var d = tbParseDate(p.title);
        if (!d) return;
        var k = tbKey(d);
        if (!tbState.dateMap[k]) tbState.dateMap[k] = [];
        tbState.dateMap[k].push(p);
      });
      var now = new Date();
      tbState.calYear = now.getFullYear();
      tbState.calMonth = now.getMonth();
      tbRenderCal();
    })
    .catch(function(e) {
      console.error('TB fetch error', e);
      document.getElementById('tb-loading').style.display = 'none';
    });
}

// ============================================================
//  CALENDAR
// ============================================================
function tbRenderCal() {
  var el = document.getElementById('tb-calendar');
  if (!el) return;
  var now = new Date(); now.setHours(0,0,0,0);
  var mNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var year = tbState.calYear, month = tbState.calMonth;
  var firstDay = new Date(year, month, 1).getDay();
  var daysInMonth = new Date(year, month + 1, 0).getDate();
  var isNow = year === now.getFullYear() && month === now.getMonth();

  var h = '<div class="tb-month-header">';
  h += '<button class="tb-cal-arrow" onclick="tbCalPrev()" ' + (isNow ? 'disabled' : '') + '>\u2190</button>';
  h += '<span>' + mNames[month] + ' ' + year + '</span>';
  h += '<button class="tb-cal-arrow" onclick="tbCalNext()">\u2192</button>';
  h += '</div><div class="tb-cal-grid">';
  ['Su','Mo','Tu','We','Th','Fr','Sa'].forEach(function(d) { h += '<div class="tb-day-label">' + d + '</div>'; });
  for (var e = 0; e < firstDay; e++) h += '<div class="tb-day tb-empty"></div>';
  for (var d = 1; d <= daysInMonth; d++) {
    var dt = new Date(year, month, d); dt.setHours(0,0,0,0);
    var k = tbKey(dt);
    var isPast = dt < now;
    var has = !isPast && !!tbState.dateMap[k];
    var cls = 'tb-day' + (isPast ? ' tb-past' : (has ? ' tb-available' : ' tb-unavailable'));
    h += '<div class="' + cls + '" data-date="' + k + '"><span class="tb-day-num">' + d + '</span>';
    if (has) h += '<span class="tb-dot"></span>';
    h += '</div>';
  }
  h += '</div>';
  el.innerHTML = h;

  el.querySelectorAll('.tb-day.tb-available').forEach(function(day) {
    day.addEventListener('click', function() {
      var k = this.getAttribute('data-date');
      tbState.dateKey = k;
      var dt = new Date(k + 'T12:00:00');
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      tbState.dateLabel = days[dt.getDay()] + ', ' + months[dt.getMonth()] + ' ' + dt.getDate();
      tbBuildSlots(tbState.dateMap[k] || []);
      tbNext();
    });
  });
}

function tbCalPrev() {
  var now = new Date();
  if (tbState.calYear === now.getFullYear() && tbState.calMonth === now.getMonth()) return;
  tbState.calMonth--; if (tbState.calMonth < 0) { tbState.calMonth = 11; tbState.calYear--; }
  tbRenderCal();
}

function tbCalNext() {
  tbState.calMonth++; if (tbState.calMonth > 11) { tbState.calMonth = 0; tbState.calYear++; }
  tbRenderCal();
}

// ============================================================
//  STEP 4: Time slots
// ============================================================
function tbBuildSlots(products) {
  var lbl = document.getElementById('tb-selected-date-label');
  if (lbl) lbl.textContent = tbState.dateLabel;
  var container = document.getElementById('tb-slots');
  if (!container) return;
  products.sort(function(a,b) { return tbTime(a.title) - tbTime(b.title); });
  container.innerHTML = '';
  products.forEach(function(p) {
    var timeLabel = tbTimeLabel(p.title);
    var btn = document.createElement('button');
    btn.className = 'tb-slot-btn';
    btn.innerHTML = '<span class="tb-slot-time">' + timeLabel + '</span><span class="tb-slot-price">' + tbFmt(p.price) + '</span>';
    btn.addEventListener('click', function() {
      container.querySelectorAll('.tb-slot-btn').forEach(function(b) { b.classList.remove('tb-selected'); });
      btn.classList.add('tb-selected');
      tbState.variantId = p.variantId;
      tbState.variantPrice = p.price;
      tbState.timeLabel = timeLabel;
      tbUpdatePriceBar(p.price, 0); // show base price immediately
      tbNext();
    });
    container.appendChild(btn);
  });
}

// ============================================================
//  STEP 5: Guests
// ============================================================

function tbBuildGuestOptions() {
  var sel = document.getElementById('tb-guests-select');
  if (sel) sel.addEventListener('change', function() {
    var opt = this.options[this.selectedIndex];
    tbState.guests = this.value;
    tbState.guestsLabel = opt.getAttribute('data-label') || opt.textContent;
    tbUpdateSubtotal();
  });
}

function tbGuestsNext() {
  var sel = document.getElementById('tb-guests-select');
  if (sel) {
    var opt = sel.options[sel.selectedIndex];
    tbState.guests = sel.value;
    tbState.guestsLabel = opt.getAttribute('data-label') || opt.textContent;
  }
  tbUpdateSubtotal();
  tbNext();
}

// ============================================================
//  STEP 6: Extra time
// ============================================================
function tbBindExtraTimeButtons() {
  var btns = document.querySelectorAll('#tb-step-extratime .tb-option-btn');
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      tbState.extraTime = btn.getAttribute('data-value');
      tbState.extraTimeLabel = btn.textContent;
      tbUpdateSubtotal();
      tbNext();
    });
  });
}

// ============================================================
//  STEP 7: Occasion
// ============================================================
function tbOccasionNext() {
  var val = (document.getElementById('tb-reason').value || '').trim();
  if (!val) {
    document.getElementById('tb-reason').focus();
    return;
  }
  tbState.occasion = val;
  tbNext();
}

// Also allow Enter key
document.addEventListener('DOMContentLoaded', function() {
  var inp = document.getElementById('tb-reason');
  if (inp) inp.addEventListener('keydown', function(e) { if (e.key === 'Enter') tbOccasionNext(); });
});

// ============================================================
//  STEP 8: Project
// ============================================================
function tbBuildProjectOptions() {
  var sel = document.getElementById('tb-project-select');
  if (!sel) return;
  TB_PROJECTS.forEach(function(cat) {
    var og = document.createElement('optgroup');
    og.label = cat.label;
    cat.options.forEach(function(o) {
      var opt = document.createElement('option');
      opt.value = o; opt.textContent = o;
      og.appendChild(opt);
    });
    sel.appendChild(og);
  });
  var og2 = document.createElement('optgroup');
  og2.label = 'Not sure yet';
  var u = document.createElement('option');
  u.value = 'Undecided'; u.textContent = 'Undecided — we\'ll discuss options';
  og2.appendChild(u);
  sel.appendChild(og2);
}

function tbProjectNext() {
  var sel = document.getElementById('tb-project-select');
  if (!sel || !sel.value) { if (sel) sel.focus(); return; }
  tbState.project = sel.value;
  tbShowReview();
  tbNext();
}


// ============================================================
//  STEP 9: Review
// ============================================================
function tbShowReview() {
  var rows = [
    { label: 'Studio', value: tbState.studioName },
    { label: 'Date', value: tbState.dateLabel },
    { label: 'Time', value: tbState.timeLabel },
    { label: 'Guests', value: tbState.guestsLabel },
    { label: 'Extra time', value: tbState.extraTimeLabel },
    { label: 'Occasion', value: tbState.occasion },
    { label: 'Project', value: tbState.project }
  ];
  var html = rows.map(function(r) {
    return '<div class="tb-review-row"><span class="tb-review-label">' + r.label + '</span><span class="tb-review-value">' + r.value + '</span></div>';
  }).join('');
  document.getElementById('tb-review-summary').innerHTML = html;
  tbUpdateSubtotal();
}

// ============================================================
//  PRICING
// ============================================================
function tbLoadExtras(cb) {
  if (Object.keys(tbExtrasVariantMap).length) { if (cb) cb(); return; }
  fetch('/products/' + TB_EXTRAS_HANDLE + '.js')
    .then(function(r) { return r.json(); })
    .then(function(p) {
      (p.variants || []).forEach(function(v) {
        tbExtrasVariantMap[v.title] = { id: v.id, priceCents: parseInt(v.price) };
      });
      if (cb) cb();
    }).catch(function(e) { console.error('TB extras error', e); });
}

function tbUpdateSubtotal() {
  tbLoadExtras(function() {
    var key = tbState.guests + ' / ' + tbState.extraTime;
    var ev = tbExtrasVariantMap[key] || null;
    var extras = (ev && key !== TB_EXTRAS_BASE_KEY) ? ev.priceCents : 0;
    var base = tbState.variantPrice || 0;
    var total = base + extras;

    // Update review step subtotal
    var baseEl = document.getElementById('tb-subtotal-base');
    var eRow = document.getElementById('tb-extras-row');
    var extrasEl = document.getElementById('tb-subtotal-extras');
    var totalEl = document.getElementById('tb-subtotal-total');
    if (baseEl) baseEl.textContent = tbFmt(base);
    if (eRow) eRow.style.display = extras > 0 ? 'flex' : 'none';
    if (extrasEl) extrasEl.textContent = tbFmt(extras);
    if (totalEl) totalEl.textContent = tbFmt(total);

    // Update sticky price bar
    tbUpdatePriceBar(base, extras);
  });
}

function tbUpdatePriceBar(base, extras) {
  var bar = document.getElementById('tb-price-bar');
  var amountEl = document.getElementById('tb-price-bar-total');
  var breakdownEl = document.getElementById('tb-price-bar-breakdown');
  if (!bar || !amountEl) return;
  if (!base) { bar.style.display = 'none'; return; }
  var total = base + extras;
  amountEl.textContent = tbFmt(total);
  if (breakdownEl) {
    if (extras > 0) {
      breakdownEl.textContent = tbFmt(base) + ' base + ' + tbFmt(extras) + ' extras';
    } else {
      breakdownEl.textContent = tbFmt(base) + ' base price';
    }
  }
  bar.style.display = 'block';
}

function tbFmt(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

// ============================================================
//  ADD TO CART
// ============================================================
function tbAddToCart() {
  var errEl = document.getElementById('tb-error');
  errEl.style.display = 'none';

  if (!tbState.variantId) {
    errEl.textContent = 'Please select a date and time first.'; errEl.style.display = 'block'; return;
  }

  var btn = document.getElementById('tb-add-to-cart');
  btn.disabled = true; btn.textContent = 'Adding\u2026';

  var key = tbState.guests + ' / ' + tbState.extraTime;
  var ev = tbExtrasVariantMap[key] || null;
  var items = [{
    id: parseInt(tbState.variantId), quantity: 1,
    properties: {
      'Number of guests': tbState.guests,
      'Party time after': tbState.extraTime,
      'Reason for get-together': tbState.occasion,
      'Project': tbState.project
    }
  }];
  if (key !== TB_EXTRAS_BASE_KEY && ev) {
    items.push({ id: ev.id, quantity: 1, properties: { '_linked_to': String(tbState.variantId) } });
  }

  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.items || (data[0] && data[0].id)) { window.location.href = '/cart'; }
      else {
        btn.disabled = false; btn.textContent = 'Book Now';
        errEl.textContent = 'Something went wrong. Please try again.'; errEl.style.display = 'block';
      }
    })
    .catch(function() {
      btn.disabled = false; btn.textContent = 'Book Now';
      errEl.textContent = 'Something went wrong. Please try again.'; errEl.style.display = 'block';
    });
}

// ============================================================
//  UTILITY
// ============================================================
function tbParseDate(title) {
  var m = title.match(/(\w{3})\s+(\d{1,2})/);
  if (!m) return null;
  var months = {Jan:0,Feb:1,Mar:2,Apr:3,May:4,Jun:5,Jul:6,Aug:7,Sep:8,Oct:9,Nov:10,Dec:11};
  var mo = months[m[1]], day = parseInt(m[2], 10);
  if (mo === undefined || isNaN(day)) return null;
  var now = new Date(), yr = now.getFullYear();
  var c = new Date(yr, mo, day);
  if (c < now) c = new Date(yr + 1, mo, day);
  return c;
}
function tbKey(d) { return d.getFullYear() + '-' + tbP(d.getMonth()+1) + '-' + tbP(d.getDate()); }
function tbP(n) { return n < 10 ? '0'+n : ''+n; }
function tbTime(title) {
  var m = title.match(/^(\*?)(\d+):?(\d*)(am|pm)/i);
  if (!m) return 9999;
  var h = parseInt(m[2],10), min = m[3] ? parseInt(m[3],10) : 0, ap = m[4].toLowerCase();
  if (ap === 'pm' && h !== 12) h += 12;
  if (ap === 'am' && h === 12) h = 0;
  return h * 60 + min;
}
function tbTimeLabel(title) {
  var m = title.match(/^(\*?\d+(?::\d+)?(?:am|pm))/i);
  return m ? m[1].replace('*','') : title.split('|')[0].trim();
}